import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { FormattedMessage } from 'react-intl'

import DisplayPrice from '../../atoms/DisplayPrice'

class Total extends PureComponent {
  render () {
    const {
      grossPrice,
      standardPrice,
      reducedInfo,
      hasFixedSummary,
      shouldDisplayFromPrice,
      showPriceOnMobile,
      wasText
    } = this.props

    if (!grossPrice) {
      return null
    }

    const totalHide = classNames('pl-0 mb-sm-3 text-sm-right col-sm-12 col-xs-6', {
      'hidden-xs': reducedInfo && !showPriceOnMobile
    })

    const summaryTotalFromId = reducedInfo && shouldDisplayFromPrice ? 'common.from' : 'common.totalPrice'
    const displayFromPrice = Number(standardPrice) > 0 && (standardPrice !== this.props.grossPrice)

    if (!hasFixedSummary) {
      return (
        <section className={totalHide}>
          {displayFromPrice &&
            <p>
              <s className='d-block tiny-xs text-right small-sm text-muted text-capitalize'>{wasText} <DisplayPrice price={standardPrice} /></s>
            </p>
          }
          <h5 className='float-none float-sm-left mt-0'><FormattedMessage id={summaryTotalFromId} /></h5>
          <div className='display-4 text-sm-right'>
            <DisplayPrice price={grossPrice} />
          </div>
        </section>
      )
    }

    // show either price or dates in the basket sticky book bar (on mobile) depending on a flag for offsite and resort hotels
    const priceSectionClasses = classNames('pl-0 mb-sm-3 text-sm-right col-sm-12 col-xs-5', {
      'hidden-xs': reducedInfo && !showPriceOnMobile
    })

    return (
      <div className={priceSectionClasses}> {/* Temp styling for demo - remove this */}
        {displayFromPrice &&
          <div className='mt-0 text-capitalize'>
            {wasText} <s><DisplayPrice price={standardPrice} /></s>
          </div>
        }
        <FormattedMessage id={summaryTotalFromId} />&nbsp;
        <span className='h2 d-block d-sm-inline m-0'>
          <DisplayPrice price={grossPrice} />
        </span>
      </div>
    )
  }
}

Total.propTypes = {
  grossPrice: PropTypes.number,
  hasFixedSummary: PropTypes.bool.isRequired,
  standardPrice: PropTypes.number
}

export default Total
